import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { subscribeApns } from './utils/api';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><App /></React.StrictMode>);

if (window.Capacitor?.isNativePlatform?.()) {
  // Register APNs token with the server when running as a native iOS app
  import('@capacitor/push-notifications').then(({ PushNotifications }) => {
    PushNotifications.addListener('registration', ({ value: token }) => {
      subscribeApns(token).catch(() => {});
    });
  });
} else if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {});
  });
}
